<script>
  import { loadingManager } from './loading-manager.js'
  import { OVERLAY_DEBOUNCE_MS } from './timing.js'
  import LoadingBar from './components/LoadingBar.svelte'
  import LoadingOverlay from './components/LoadingOverlay.svelte'

  if (import.meta.env.DEV) {
    import('./devtools.js')
  }

  let state = $state(loadingManager.state)
  let showOverlay = $state(false)
  let overlayTimer

  $effect(() => {
    return loadingManager.subscribe((s) => {
      state = s
    })
  })

  // Bootstrap overlay — debounced 100ms to prevent flash on fast startup
  $effect(() => {
    if (state.bootstrapLoading) {
      clearTimeout(overlayTimer)
      overlayTimer = setTimeout(() => { showOverlay = true }, OVERLAY_DEBOUNCE_MS)
    } else {
      clearTimeout(overlayTimer)
      showOverlay = false
    }
    return () => clearTimeout(overlayTimer)
  })
</script>

{#if showOverlay && state.bootstrapLoading}
  <LoadingOverlay message="" fullPage={true} />
{/if}

<LoadingBar routeProgress={state.routeProgress} routeLoading={state.routeLoading} />
